// 客户列表
export const customerList = [{
  name: '南京梓如商旅集团',
  id: '1'
}];
// 客户架构师
export const data = [{
  id: 0,
  name: '南京梓如商旅集团',
  operatingState: true,
  orgType: 0,
  orgTypeName: '总公司',
  parentId: 0,
  children: [{
    id: 11,
    name: '部门1',
    operatingState: false,
    orgType: 145,
    orgTypeName: '部门',
    parentId: 0,
    status: 1
  }]
}];
//职级关系
export const rankList = [{
  name: '上下级关系',
  id: '1'
}];
//列表数据
export const tableData = [{
  id: 1,
  status: 1,
  statusName: '在职',
  structureName: '部门1',
  jobNo: 1,
  name: '张三',
  postName: '业务员'
}];
export const infoObj = {
  'id': 4,
  'customerId': 2,
  'structureId': 2,
  'postId': 14,
  'jobNo': '',
  'name': '张三',
  'mobile': '18932506276',
  'certificateType': 1,
  'certificateNo': '370921198612173617',
  'sex': 1,
  'nation': '\u6c49\u65cf',
  'email': '',
  'address': '\u5317\u4eac\u5e02\u671d\u9633\u533a',
  'bank': '\u5317\u4eac\u5e02\u6f58\u5bb6\u56ed\u94f6\u884c',
  'bankNo': '666666666666666',
  'remark': '',
  'idCardFront': {
    'name': 'F404A1A2-D116-464D-A641-0932312A07B6_1_201_a.jpeg',
    'url': 'https:\/\/insurforce-1304543527.cos.ap-beijing.myqcloud.com\/insurforce\/certificate\/000\/000\/000\/004\/UmpRd05FRXhRVEl0UkRFeE5pMDBOalJFTFVFMk5ERXRNRGt6TWpNeE1rRXdOMEkyWHpGZk1qQXhYMkU9.jpeg',
    'format': 'jpeg'
  },
  'idCardBack': {
    'name': '4B5AC01A-49BE-4532-8259-9A81440BE363_1_201_a.jpeg',
    'url': 'https:\/\/insurforce-1304543527.cos.ap-beijing.myqcloud.com\/insurforce\/certificate\/000\/000\/000\/004\/TkVJMVFVTXdNVUV0TkRsQ1JTMDBOVE15TFRneU5Ua3RPVUU0TVRRME1FSkZNell6WHpGZk1qQXhYMkU9.jpeg',
    'format': 'jpeg'
  },
  'diploma': {
    'name': '943FCED0-BA3B-4E78-BAAF-A55F4ADDB81A_1_201_a.jpeg',
    'url': 'https:\/\/insurforce-1304543527.cos.ap-beijing.myqcloud.com\/insurforce\/certificate\/000\/000\/000\/004\/T1RRelJrTkZSREF0UWtFelFpMDBSVGM0TFVKQlFVWXRRVFUxUmpSQlJFUkNPREZCWHpGZk1qQXhYMkU9.jpeg',
    'format': 'jpeg'
  },
  'bankCard': {
    'name': '9534B217-1819-4B10-AEDC-6A9CA37AC71B_1_201_a.jpeg',
    'url': 'https:\/\/insurforce-1304543527.cos.ap-beijing.myqcloud.com\/insurforce\/certificate\/000\/000\/000\/004\/T1RVek5FSXlNVGN0TVRneE9TMDBRakV3TFVGRlJFTXROa0U1UTBFek4wRkROekZDWHpGZk1qQXhYMkU9.jpeg',
    'format': 'jpeg'
  },
  'laborContract': {},
  'resignType': null,
  'resignReason': '',
  'resignAt': null,
  'status': 1,
  'entryAt': '2022-02-25',
  'createAt': '2022-02-28 14:52:57',
  'updateAt': '2022-02-28 14:54:49',
  'companyWorkerId': 4,
  'structureName': '\u6280\u672f\u90e8',
  'postName': 'qa\u6d4b\u8bd5',
  'migrateInfo': {},
  resource: '1',
  isCertificate: '1',
  rank: '1'
};